import React from "react";
import { MainHeader, MainWrapper, StatsWrapper } from "./styles";
import Spinner from "../../components/Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { DoughnutChart } from "../../components/DoughnutChart";
import { LineChart } from "../../components/LineChart";
import { BarChart } from "../../components/BarChart";
import { Divider } from "@mui/material";
import { HeaderWrapper } from "../History/styles";
import StatCard from "../../components/StatCard/StatCard";
import { getStats } from "../../services/stats/getStats";
import theme from "../../theme/theme";

const Statistics = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");
  const userType = localStorage.getItem("user_type");

  const navigate = useNavigate();

  // ------------------- STATES -------------------
  const [loadingStatistics, setLoadingStatistics] = React.useState(false);
  const [statistics, setStatistics] = React.useState<any>(null);

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    setLoadingStatistics(true);
    getStatistics();
  }, []);

  // ------------------- GET RESOURCES FROM API -------------------
  const getStatistics = async () => {
    await getStats(jwt!)
      .then((response) => {
        setStatistics(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
    setLoadingStatistics(false);
  };

  // function convertTime(minutes: number): string {
  //   if (minutes < 0) {
  //     throw new Error("El número de minutos no puede ser negativo.");
  //   }
  
  //   const hours = Math.floor(minutes / 60);
  //   const remainingMinutes = minutes % 60;
  
  //   const hoursText = hours > 0 ? `${hours} h` : "";
  //   const minutesText = remainingMinutes > 0 ? `${remainingMinutes} min` : "";
  
  //   if (hoursText && minutesText) {
  //     return `${hoursText} ${minutesText}`;
  //   } else if (hoursText) {
  //     return hoursText;
  //   } else {
  //     return minutesText;
  //   }
  // }

  return (
    <>
      {!loadingStatistics ? (
        <>
          {/* <DoughnutChart dataProps={[10, 30]} />
                    <LineChart labelProps={["Enero 2023", "Febrero 2023"]} dataProps={[10, 30]} />
                    <BarChart labelProps={["Atendidas", "No atendidas"]} dataProps={[10, 30]} /> */}

          <MainWrapper>
            <MainHeader>Mis Estadísticas</MainHeader>
            <HeaderWrapper></HeaderWrapper>
            <Divider sx={{ marginBottom: "20px" }} />
            <StatsWrapper>
              <StatCard
                icon="Devices"
                color = {theme.color.lemon}
                category="Último equipo reservado"
                content={statistics?.last_hardware || "Sin reservas por ahora"}
              />
              <StatCard
                icon="AdminPanelSettings"
                color = {theme.color.apricot}
                category="Última licencia reservada"
                content={statistics?.last_software || "Sin reservas por ahora"}
              />
              <StatCard
                icon="MeetingRoom"
                color = {theme.color.denim}
                category="Último espacio reservado"
                content={statistics?.last_room || "Sin reservas por ahora"}
              />
              <StatCard
                icon="AccessTime"
                color = {theme.color.ruby}
                category="Tiempo invertido en espacios"
                content={
                  typeof statistics?.total_time && statistics?.total_time >= 1
                    ? statistics?.total_time.toString()
                    : "Sin reservas por ahora"
                }
                // content = "1.166"
                time={statistics?.total_time && statistics?.total_time >= 1 ? true : false}
                // time={true}
              />
              <StatCard
                icon="ChangeCircle"
                color = {theme.color.honey}
                category="Recurso más reservado"
                content={statistics?.most_used || "Sin reservas por ahora"}
              />
            </StatsWrapper>
          </MainWrapper>
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default Statistics;
